import { type ReactNode } from 'react';

/** Rótulo em pílula acima dos títulos de seção, como nas referências. */
export function SectionLabel({
  children,
  invert = false,
}: {
  children: ReactNode;
  invert?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[13px] font-medium ${
        invert
          ? 'border-white/15 bg-white/5 text-white/80'
          : 'border-(--lp-line) text-(--lp-body) bg-white'
      }`}
    >
      <span className="bg-(--lp-blue) size-1.5 rounded-full" />
      {children}
    </span>
  );
}
